import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Slider } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateZoomRatio } from '../../../redux/board/reducer';
import { eventBus, BUS_EVENTS } from '../../../utils';
import { ZOOM_DEFAULT, ZOOM_LIMIT, ZOOM_RAITO } from '../../../utils/constants';
import './styles.scss';

const MIN_ZOOM = 100 * ZOOM_LIMIT.MIN;
const MAX_ZOOM = 100 * ZOOM_LIMIT.MAX;

const ResizeForm = () => {
  const zoom = useSelector((state) => state.board.zoomRatio);
  const [key, setKey] = useState(Date.now());
  const dispatch = useDispatch();

  const onPlus = () => {
    eventBus.emit(BUS_EVENTS.ZOOM, Math.min(zoom + ZOOM_RAITO, MAX_ZOOM), null, true);
    eventBus.emit(BUS_EVENTS.UPDATE_ZOOM_SLIDER);
  };

  const onSub = () => {
    eventBus.emit(BUS_EVENTS.ZOOM, Math.max(zoom - ZOOM_RAITO, MIN_ZOOM), null, true);
    eventBus.emit(BUS_EVENTS.UPDATE_ZOOM_SLIDER);
  };

  const onChange = (zoomValue) => {
    eventBus.emit(BUS_EVENTS.ZOOM, zoomValue, null, false);
  };

  const rerenderZoomSlider = (newZoom) => {
    if (newZoom) dispatch(updateZoomRatio(newZoom));
    setKey(Date.now());
  };

  useEffect(() => {
    eventBus.on(BUS_EVENTS.UPDATE_ZOOM_SLIDER, rerenderZoomSlider);
    return () => eventBus.off(BUS_EVENTS.UPDATE_ZOOM_SLIDER, rerenderZoomSlider);
  }, []);

  return (
    <div className="mo-editor__zoom">
      <div className="item" onClick={onSub}>
        <MinusOutlined />
      </div>
      <Slider
        key={key}
        className="item slide"
        tooltip={{ placement: 'bottom' }}
        defaultValue={zoom || ZOOM_DEFAULT}
        min={MIN_ZOOM}
        max={MAX_ZOOM}
        step={5}
        onChange={onChange}
      />
      <div className="item" onClick={onPlus}>
        <PlusOutlined />
      </div>
    </div>
  );
};

export default ResizeForm;
